import Vue from "vue";
import VueI18n from "vue-i18n";
import { getlanguageList } from "@/api/ZQpublicApi";

Vue.use(VueI18n);

const langMap = {
  "0": "zh",
  "1": "vi",
  "2": "en"
};

function getDefaultLang() {
  try {
    var match = document.cookie.match(/language=([^;]+)/);
    var code = match ? match[1] : "0";
    return langMap[code] || "zh";
  } catch (e) {
    return "zh";
  }
}

const messages = {
  zh: {},
  vi: {},
  en: {}
};

const i18n = new VueI18n({
  locale: getDefaultLang(),
  messages,
  silentTranslationWarn: true,
  fallbackLocale: "zh"
});

window.I18N_MESSAGES = {
  zh: {},
  vi: {},
  en: {}
};

console.log("【i18n】文件已加载");

export async function initI18n() {
  console.log("【i18n】initI18n 开始执行");
  try {
    console.log("【i18n】开始请求语言接口...");

    const res = await getlanguageList({});
    console.log("【i18n】接口返回结果：", res);
    const list = res && res.list ? res.list : [];
    console.log("【i18n】接口返回列表长度：", list.length);

    window.I18N_MESSAGES = { zh: {}, vi: {}, en: {} };

    list.forEach(item => {
      var key = (item.firstName || "").trim();
      if (!key) return;

      window.I18N_MESSAGES.zh[key] = item.ZNCode || key;
      window.I18N_MESSAGES.en[key] = item.ENCode || key;
      window.I18N_MESSAGES.vi[key] = item.VNCode || key;
    });

    i18n.setLocaleMessage("zh", Object.assign({}, window.I18N_MESSAGES.zh));
    i18n.setLocaleMessage("vi", Object.assign({}, window.I18N_MESSAGES.vi));
    i18n.setLocaleMessage("en", Object.assign({}, window.I18N_MESSAGES.en));

    console.log("【i18n】语言包加载成功", window.I18N_MESSAGES);
  } catch (err) {
    console.error("【i18n】语言加载失败", err);
  }
}

// 自定义翻译函数
i18n.t = function(key) {
  const lang = i18n.locale;
  return (
    (window.I18N_MESSAGES[lang] && window.I18N_MESSAGES[lang][key]) ||
    window.I18N_MESSAGES.zh[key] ||
    key
  );
};

// 自动执行：文件加载完成后立刻请求语言包
initI18n().catch(err => console.error("【i18n】自动加载失败", err));

export default i18n;
